import { Component } from 'react';
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { CONSTANTS } from "../config/Constants";
import { ReactComponent as Logo } from "../design/controller.svg";
// import IconData from "../images/icon.png";
import ApplicationState from "../mobx/ApplicationState";
import NavigationLinks from '../config/NavigationLinks';

import "./AppHeader.scss";

class AppHeader extends Component {
    constructor() {
        super();
        this.links = NavigationLinks.find(g => g.groupName === 'community').elements
        this.logo = window.kiosk?.icon ? <img alt="Logo" src={window.kiosk.icon} /> : <Logo alt="logo" />;
    }
    doClick(event) {
        if (window.innerWidth < CONSTANTS.MobileCollapseWidth && !window.location.pathname.startsWith('/play/')) {
            ApplicationState.toggleNavIsOpen();
            event.preventDefault();
        }
    }

    getItem(link) {
        if (link.href.startsWith('/')) {
            return (<LinkContainer key={link.href} to={link.href}>
                <NavDropdown.Item href={link.href}>
                    {link.name}
                </NavDropdown.Item>
            </LinkContainer>)
        } else {
            return (<NavDropdown.Item key={link.href} href={link.href} target="_blank" rel="noreferrer">
                {link.name}
            </NavDropdown.Item>)
        }
    }

    render() {
        return (
            <header className="app-header">
                <Navbar bg="dark" variant="dark" fixed="top">
                    <LinkContainer to="/" onClick={event => this.doClick(event)}>
                        <Navbar.Brand href="/">
                            {this.logo}{" "}
                            {/* <img alt="icon" src={IconData} /> */}
                            {CONSTANTS.ApplicationName}
                        </Navbar.Brand>
                    </LinkContainer>
                    <Nav className="me-auto"></Nav>
                    <Nav className="comm-dropdown">
                        <NavDropdown title="Community" id="comm-dropdown">
                            {this.links.map(link => this.getItem(link) )}
                        </NavDropdown>
                    </Nav>
                </Navbar>
            </header>
        );
    }
}

export default AppHeader;
